import { CreateOrderResponse, Product } from 'src/api/@generated/backend';

export interface OrderState {
  state: OrderStates;
  confirmation?: CreateOrderResponse;
  selectedProduct?: Product;
}

export enum OrderStates {
  IDLE = 'IDLE',
  START = 'START',
  ABORT = 'ABORT',
  DONE = 'DONE',
}
